import { render } from "./ModalActions.vue?vue&type=template&id=c5f2679c"
import script from "./ModalActions.vue?vue&type=script&lang=ts"
export * from "./ModalActions.vue?vue&type=script&lang=ts"
script.render = render

export default script